import React from 'react';
import { cn } from './cn';
import { Eyebrow } from './Tag';

// Section header: eyebrow tag, large serif title, optional description, right-aligned actions.
export function PageHeader({ eyebrow, title, description, actions, className }) {
    return (
        <div className={cn('flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between', className)}>
            <div className="max-w-2xl">
                {eyebrow && <Eyebrow className="mb-4">{eyebrow}</Eyebrow>}
                <h1 className="font-serif text-4xl leading-[1.05] text-espresso sm:text-5xl">{title}</h1>
                {description && <p className="mt-3 text-espresso-soft/80">{description}</p>}
            </div>
            {actions && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
        </div>
    );
}
